import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { IBookingAttachment } from '@homeporter/types';
import { COLORS } from '../utils/colors';
import ViewAttachments from './ViewAttachments';

interface ImagePreviewSelectorProps {
  label: string;
  type: string;
  selectedFile: File | undefined;
  setSelectedFile: (file: File | undefined) => void;
  url: string;
}

const FilePreviewSelector: React.FC<ImagePreviewSelectorProps> = ({
  label,
  type,
  selectedFile,
  setSelectedFile,
  url,
}) => {
  const [displayFile, setDisplayFile] = useState<IBookingAttachment[]>([]);
  const [selectedFileIndex, setSelectedFileIndex] = useState<number>(-1);

  const handleClick = () => {
    if (selectedFile) {
      setSelectedFileIndex(0);
      setDisplayFile([
        {
          name: selectedFile.name,
          type: selectedFile.type,
          size: selectedFile.size,
          url: '',
          last_modified: selectedFile.lastModified,
          uploaded_at: new Date().toISOString(),
          file: selectedFile,
          id: 0,
        },
      ]);
    } else if (url) {
      const fileName = url.includes('/') ? url.split('/').pop() || '' : url;

      const fileType = fileName.split('.').pop() || '';
      console.log('::::fileType', fileType);
      console.log('::::fileName', fileName);

      const extension = fileName.split('.').pop() || '';
      const type = `${extension === 'pdf' ? 'application' : 'image'}/${extension}`; //TODO: store as IBookingAttachment, will require db migration

      setSelectedFileIndex(0);
      setDisplayFile([
        {
          name: fileName,
          type,
          size: 0,
          url,
          last_modified: 0,
          uploaded_at: '',
          id: 0,
        },
      ]);
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setDisplayFile([]);
    setSelectedFile(file);
    console.log('Replace image:', url, file);
  };

  return (
    <>
      <ViewAttachments
        attachments={displayFile}
        selectedAttachmentIndex={selectedFileIndex}
        setSelectedAttachmentIndex={setSelectedFileIndex}
      />
      <Box sx={{ mt: '1rem' }}>
        <Typography variant="subtitle2">{label}:</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography
            variant="body2"
            sx={{
              wordBreak: 'break-all',
              flex: 1,
              cursor: 'pointer',
              ...((selectedFile || url) && {
                color: COLORS.DARK_GREY,
                '&:hover': {
                  textDecoration: 'underline',
                  color: 'rgba(0, 0, 255, 0.75)',
                },
              }),
            }}
            onClick={handleClick}>
            {selectedFile ? (
              selectedFile.name
            ) : url?.length ? (
              url.split('/').pop() || ''
            ) : (
              <i>not selected</i>
            )}
          </Typography>

          {selectedFile ? (
            <Button
              onClick={() => setSelectedFile(undefined)}
              variant="text"
              size="small">
              Drop
            </Button>
          ) : (
            <Button component="label" variant="text" size="small">
              {url ? 'Replace' : 'Select'}
              <input
                type="file"
                hidden
                accept={type}
                onChange={handleFileChange}
              />
            </Button>
          )}
        </Box>
      </Box>
    </>
  );
};

export default FilePreviewSelector;
